module.exports = coreApis.lifeCycle;